import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  page: 1,
  param: false,
  keyword: '',
  search: false,
  picSear: false,
  searchPic: 1,
  searchType1: 0,
  searchType2: 0,
  checkedUse: false,
  orderUse: 0
}

export const ItemPageSlice = createSlice({
  name: 'itempageinfo',
  initialState,
  reducers: {
    setItemPageInit: (state, action) => {
        state.page = 1
        state.param = false
        state.keyword = ''
        state.search = false
        state.picSear = false
        state.searchPic = 1
        state.searchType1 = 0
        state.searchType2 = 0
        state.checkedUse = false
        state.orderUse = 0
    },

    setPageItm: (state, action) => {
      state.page = action.payload
    },

    setParamItm: (state, action) => {
      state.param = action.payload
    },
    setKeywordItm: (state, action) => {
      state.keyword = action.payload
    },
    setSearchItm: (state, action) => {
      state.search = action.payload
    },
    setPicSearItm: (state, action) => {
      state.picSear = action.payload
    },
    setSearchPicItm: (state, action) => {
      state.searchPic = action.payload
    },

    setSearchType1Itm: (state, action) => {
      state.searchType1 = action.payload
    },
    setSearchType2Itm: (state, action) => {
      state.searchType2 = action.payload
    },
    setCheckedUseItm: (state, action) => {
      state.checkedUse = action.payload
    },
    setOrderUseItm: (state, action) => {
      state.orderUse = action.payload
    },
  },
})

export const { 
    setItemPageInit,
    setPageItm,

    setParamItm,
    setKeywordItm,
    setSearchItm,
    setPicSearItm,
    setSearchPicItm,

    setSearchType1Itm,
    setSearchType2Itm,
    setCheckedUseItm,
    setOrderUseItm 
    } = ItemPageSlice.actions

export default ItemPageSlice.reducer